module.exports = __webpack_public_path__ + "img/close.1adb226c.svg";